<template>
  <td class="text-uppercase">
    <template v-if="inscription.assistants && inscription.assistants.length > 0">
      <div v-for="item in inscription.assistants" :key="item.UUID">
        {{ item.firstName }} {{ item.lastName }}
      </div>
    </template>

    <template v-else-if="inscription.createdBy">
      <div>
        {{ inscription.author_name }}
      </div>
    </template>
  </td>
  <td class="text-uppercase">
    <div v-for="item in inscription.disabilityPersons" :key="item.UUID">
      {{ item.firstName }} {{ item.lastName }}
    </div>
  </td>
  <td class="text-center">
    <div>{{ formatDate(inscription.createdAt) }}</div>
  </td>
  <td class="text-center">
    <template v-if="inscription.childcare">
      <i class="fas fa-check text-success fa-xl"></i>
      <span
        data-bs-toggle="tooltip" 
        title="Información de niños inscritos en ludoteca"
      >
        <span
          v-if="inscription.childs && inscription.childs.length > 0"
          class="badge rounded-pill bg-info ms-2 badge-hover-outline"
          style="cursor:pointer; font-size: 0.85rem;"
          data-bs-toggle="modal"
          :data-bs-target="'#childrenModal_' + inscription.UUID"
        >+ {{ inscription.childs.length }}</span>
      </span>
    </template>
    <i v-else class="fas fa-times text-danger fa-xl"></i>
  </td>
  <td class="text-center">
    <!-- <button class="btn btn-sm btn-outline-dark m-1" data-bs-toggle="modal" :data-bs-target="'#modalEditLesson'+id"><i class="fas fa-edit"></i></button> -->
    <button
      v-if="inscription.authorizeHygieneFeeding"
      class="btn btn-sm btn-outline-info m-1"
      data-bs-toggle="modal"
      :data-bs-target="'#authPDF_' + inscription.UUID"
      @click="generateAuthorizationPDF()"
      title="Autorización aseo y alimentación"
    >
      <i class="fas fa-file-pdf"></i>
    </button>
    <button
      class="btn btn-sm btn-outline-danger m-1"
      @click="deleteInscription()"
    >
      <i class="fas fa-trash"></i>
    </button>
  </td>

  <!-- Modal hermanos/niños en ludoteca -->
  <div
    v-if="(inscription.disabilityPersons && inscription.disabilityPersons.length > 0) || (inscription.childs && inscription.childs.length > 0)"
    class="modal fade"
    :id="'childrenModal_' + inscription.UUID"
    tabindex="-1"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            Hermanos/niños en ludoteca
            <span class="badge bg-secondary ms-2">{{ (inscription.disabilityPersons?.length || 0) + (inscription.childs?.length || 0) }}</span>
          </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <template v-if="inscription.disabilityPersons && inscription.disabilityPersons.length > 0">
            <h6 class="text-muted mb-2">
              <i class="fas fa-wheelchair me-1"></i> Persona con discapacidad en Ludoteca
            </h6>
            <ul class="list-group list-group-flush mb-3">
              <li
                v-for="dp in inscription.disabilityPersons"
                :key="dp.UUID"
                class="list-group-item d-flex justify-content-between align-items-center"
              >
                <span class="text-uppercase fw-semibold">{{ dp.firstName }} {{ dp.lastName }}</span>
                <span class="text-danger small">
                  <i class="fas fa-circle-info me-1"></i>
                  {{ dp.degree || 'Grado no especificado' }}
                </span>
              </li>
            </ul>
          </template>

          <template v-if="inscription.childs && inscription.childs.length > 0">
            <h6 class="text-muted mb-2">
              <i class="fas fa-children me-1"></i> Hermanos o otros niños en Ludoteca
            </h6>
            <ul class="list-group list-group-flush">
              <li
                v-for="child in inscription.childs"
                :key="child.UUID"
                class="list-group-item d-flex justify-content-between align-items-center"
              >
                <span class="text-uppercase fw-semibold">{{ child.firstName }} {{ child.lastName }}</span>
                <span v-if="child.hasDisability" class="text-danger small">
                  <i class="fas fa-circle-info me-1"></i>
                  Con discapacidad{{ child.disabilityDegree ? ': ' + child.disabilityDegree : '' }}
                </span>
                <span v-else class="text-muted small">Sin discapacidad</span>
              </li>
            </ul>
          </template>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal autorización aseo y alimentación -->
  <div
    class="modal fade"
    :id="'authPDF_' + inscription.UUID"
    tabindex="-1"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Autorización aseo y alimentación</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body" style="height: 68vh;">
          <div
            v-if="pdfLoading"
            class="d-flex justify-content-center align-items-center h-100"
          >
            <div class="text-center">
              <div
                class="spinner-border text-primary mb-3"
                role="status"
                style="width: 3rem; height: 3rem;"
              >
                <span class="visually-hidden">Cargando...</span>
              </div>
              <h5>Generando documento...</h5>
            </div>
          </div>

          <embed
            v-else-if="pdf"
            :src="pdf"
            :key="pdf"
            type="application/pdf"
            width="100%"
            height="100%"
            style="border: none;"
          />

          <div
            v-else
            class="d-flex justify-content-center align-items-center h-100 text-danger"
          >
            <div class="text-center">
              <i class="fa-solid fa-triangle-exclamation fa-3x mb-3"></i>
              <h5>No se pudo cargar el documento.</h5>
              <p>Inténtalo de nuevo o contacta con soporte.</p>
            </div>
          </div>
        </div>
        <div class="modal-footer justify-content-between" v-if="pdf && !pdfLoading">
          <small class="text-muted text-start" style="max-width: 60%; font-size: 12.75px">
            <i class="fas fa-circle-info me-1"></i>
            La generación automática de este documento fue implementada a medios de mayo de 2026. Las inscripciones previas a esa fecha pueden no contener todos los campos necesarios para rellenar correctamente esta autorización.
          </small>
          <a
            :href="pdf"
            :download="`autorizacion_aseo_alimentacion_${inscription.UUID}.pdf`"
            class="btn btn-info d-flex align-items-center gap-2"
          >
            <i class="fas fa-download fa-2x"></i>
            <span style="font-size: 0.8em;">Descargar este archivo nombrado con el identificador<br>
            único de su inscripción correspondiente como sufijo</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InscriptionService from "../../../services/inscription.service";

import Swal from "sweetalert2";

export default {
  name: "InscriptionRow",
  components: {},
  props: {
    inscription: Object,
  },
  data() {
    return {
      pdfLoading: false,
      pdf: null,
    };
  },
  methods: {
    async generateAuthorizationPDF() {
      this.pdfLoading = true;
      this.pdf = null;
      try {
        const response = await InscriptionService.getHygieneFeedingAuthorizationPDF(
          this.inscription.UUID
        );
        if (response.status === 200) {
          const fileURL = URL.createObjectURL(
            new File([response.data], `autorizacion_aseo_alimentacion_${this.inscription.UUID}.pdf`, { type: "application/pdf" })
          );
          setTimeout(() => {
            this.pdf = fileURL;
            this.pdfLoading = false;
          }, 500);
        } else {
          this.pdfLoading = false;
        }
      } catch (error) {
        console.error("Error PDF:", error);
        this.pdfLoading = false;
      }
    },

    formatDate(value) {
      if (!value) return "";
      const d = new Date(value);
      const p = (n) => String(n).padStart(2, "0");
      return `${p(d.getDate())}/${p(d.getMonth() + 1)}/${String(d.getFullYear()).slice(-2)} ${p(d.getHours())}:${p(d.getMinutes())}`;
    },

    async deleteInscription() {
      Swal.fire({
        title: "¿Estás seguro?",
        text: "Una vez eliminada la inscripción no podrás recuperar los datos",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "¡Sí, eliminar!",
        cancelButtonText: "Cancelar",
      }).then(async (result) => {
        if (result.isConfirmed) {
          let response = await InscriptionService.deleteInscription(
            this.inscription.UUID
          );
          if (response.status == 200 || response.status == 204) {
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Se ha borrado correctamente.",
              showConfirmButton: false,
              timer: 1500,
              backdrop: false,
              toast: true,
            });
          }
          this.$router.go();
        }
      });
    },
  },
};
</script>

<style>
.badge-hover-outline {
  /* Smooth transition for the effect */
  transition: all 0.2s ease-in-out;
  border: 1px solid transparent;
}

.badge-hover-outline:hover {
  /* Remove solid background */
  background-color: transparent !important;
  
  /* Add border and change text color to match the original info color */
  border: 1px solid #0dcaf0; 
  color: #0dcaf0;
}
</style>
